import React from "react";

import "./stylesIOSNotificationPreview.css";

import CashIcon from "../../../../../../assets/icons/ic_cash.svg";
import { ClockCircleOutlined } from "@ant-design/icons";

function IOSNotificationPreview({ notificationData }) {
  const { title, description, dateTime, timeLeft } = notificationData;

  return (
    <div className="ios-notification-preview-container">
      <h3>Communication Preview</h3>
      <button className="notification-button">
        <span>Notification</span>
      </button>
      <div className="ios-preview">
        <div className="ios-preview-content">
          <div className="ios-preview-content-left-content">
            <img src={CashIcon} alt="cash icon" className="cash-svg" />
          </div>
          <div className="ios-preview-content-right-content">
            <span className="ios-preview-content-date">{dateTime}</span>
            <span className="ios-preview-content-hours-left">
              <ClockCircleOutlined className="ios-preview-content-clock-icon" />
              {timeLeft}
            </span>
            <h4 className="ios-preview-content-title">{title}</h4>
            <span className="ios-preview-content-description">
              {description}
            </span>
            <div className="buttons">
              <button className="ios-preview-content-button learn-more">
                <span>Learn more</span>
              </button>
              <button className="ios-preview-content-button go-to-wallet">
                <span>Go to Wallet</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IOSNotificationPreview;
